import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.21 19.77a8.4 8.4 0 0 0 4.142 1.082c4.674 0 8.5-3.826 8.5-8.5 0-4.675-3.826-8.5-8.5-8.5-4.675 0-8.5 3.825-8.5 8.5 0 1.504.392 2.917 1.08 4.141l-1.08 4.359z",
      fill: "none",
      stroke: "black",
      "stroke-width": "1.2",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.354 13.349c.352.35 1.915 1.759 2.427 1.246.141-.14.526-.704.746-.923.748-.748 1.674.11 2.225.66.045.045.957.893-.168 2.018-2.012 2.01-5.618-.856-6.5-1.73-.875-.883-3.742-4.49-1.73-6.5 1.125-1.125 1.972-.213 2.017-.168.55.55 1.409 1.476.66 2.225-.22.22-.782.604-.923.745-.513.512.896 2.075 1.246 2.427",
      fill: "black",
      stroke: "none"
    }, null, -1)
  ])))
}
export default { render: render }